import State from 'store/State';
import {
    selectWidgetInstanceConfig,
    selectWidgetInstancesState,
} from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';
import { WidgetId } from 'widgets/WidgetId';
import { CapsuleContainerWidgetConfigState } from 'widgets/tiles/store/config/CapsuleContainerWidgetConfigState';

export const selectTilesWidgetsState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.TILES];

export const selectTilesState = (state: State, widgetKey: string) =>
    selectTilesWidgetsState(state)[widgetKey];

export const selectAllCapsuleContainerKeys = (state: State) =>
    Object.keys(selectTilesWidgetsState(state));

export const selectParentCapsuleContainerKey: (
    state: State,
    capsuleWidgetKey: string
) => string | undefined = (state, capsuleWidgetKey) => {
    for (const capsuleContainerWidgetKey of selectAllCapsuleContainerKeys(
        state
    )) {
        const capsuleContainerState = selectTilesState(
            state,
            capsuleContainerWidgetKey
        );
        const tiles: WidgetId[] = capsuleContainerState?.config?.tiles ?? [];
        if (tiles.find((c) => c.widgetKey === capsuleWidgetKey)) {
            return capsuleContainerWidgetKey;
        }
    }
};

export const selectParentCapsuleContainerConfig: (
    state: State,
    capsuleWidgetKey: string
) => CapsuleContainerWidgetConfigState | undefined = (
    state,
    capsuleWidgetKey
) => {
    const capsuleContainerWidgetKey = selectParentCapsuleContainerKey(
        state,
        capsuleWidgetKey
    );
    return capsuleContainerWidgetKey
        ? selectTilesState(state, capsuleContainerWidgetKey)?.config
        : undefined;
};

export const selectParentCapsuleContainerConfiguredSymbol: (
    state: State,
    capsuleWidgetKey: string
) => string | undefined = (state, capsuleWidgetKey) => {
    return selectParentCapsuleContainerConfig(state, capsuleWidgetKey)?.symbol;
};

export const selectConfiguredSymbolForWidgetOrItsCapsuleContainer: (
    state: State,
    widgetId: WidgetId
) => string | undefined = (state, widgetId) => {
    const capsuleContainerConfiguredSymbol =
        selectParentCapsuleContainerConfiguredSymbol(state, widgetId.widgetKey);
    if (capsuleContainerConfiguredSymbol) {
        return capsuleContainerConfiguredSymbol;
    }
    const config = selectWidgetInstanceConfig(state, widgetId) ?? {};
    return config?.symbol;
};
